export default "__VITE_ASSET__0a36aee5__"